import { render } from "./ResetPassword.vue?vue&type=template&id=3480a932&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=3480a932&scoped=true&lang=css"
import "./ResetPassword.vue?vue&type=style&index=1&id=3480a932&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3480a932"]])

export default __exports__